// extracted by mini-css-extract-plugin
export default {"card":"selectProblemCard_card__fh0d7","icon":"selectProblemCard_icon__cytIA","selectedCard":"selectProblemCard_selectedCard__jCIWr"};